import { PaginationResponse } from '@repo/ui/data-table'

import { TransferPayment } from '../../lib/types/models/transfer/transfer-payments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTransferPayments(transferId: number) {
  return restApiClient
    .url(constructApiUrl(API.transfer.getAllPayments.url, { transferId }))
    .get<PaginationResponse<TransferPayment>>()
}
